import React, { type FC } from 'react';

import { IconProps } from '.';

export const AppleIcon: FC<IconProps> = ({ className = '' }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_349_2668)">
        <path
          d="M18.16 15.5861C17.8576 16.2848 17.4996 16.928 17.0848 17.5194C16.5194 18.3255 16.0564 18.8835 15.6996 19.1934C15.1466 19.702 14.554 19.9625 13.9194 19.9773C13.4639 19.9773 12.9145 19.8477 12.2751 19.5847C11.6335 19.323 11.0439 19.1934 10.5047 19.1934C9.93932 19.1934 9.33292 19.323 8.6843 19.5847C8.03469 19.8477 7.51138 19.9847 7.11127 19.9983C6.50277 20.0242 5.89624 19.7563 5.29083 19.1934C4.90442 18.8563 4.4211 18.2786 3.84211 17.4601C3.2209 16.586 2.71017 15.5725 2.31006 14.417C1.88156 13.1689 1.66675 11.9603 1.66675 10.7902C1.66675 9.44984 1.95637 8.29383 2.53647 7.32509C2.99238 6.54697 3.59891 5.93316 4.35802 5.48255C5.11713 5.03195 5.93735 4.80233 6.82066 4.78764C7.30398 4.78764 7.93778 4.93714 8.72541 5.23096C9.51082 5.52576 10.0151 5.67526 10.2362 5.67526C10.4015 5.67526 10.9618 5.50045 11.9115 5.15195C12.8096 4.82875 13.5676 4.69492 14.1886 4.74764C15.8712 4.88344 17.1354 5.54675 17.9761 6.74178C16.4712 7.6536 15.7268 8.93072 15.7416 10.5691C15.7552 11.8452 16.2181 12.9071 17.128 13.7503C17.5403 14.1417 18.0008 14.4441 18.5131 14.6589C18.402 14.9812 18.2847 15.2898 18.16 15.5861ZM14.3009 0.400114C14.3009 1.40034 13.9355 2.33425 13.2071 3.19867C12.3281 4.22629 11.265 4.8201 10.112 4.7264C10.0973 4.60641 10.0888 4.48011 10.0888 4.3474C10.0888 3.38718 10.5068 2.35956 11.2492 1.51934C11.6198 1.09392 12.0911 0.74019 12.6627 0.458013C13.233 0.180046 13.7725 0.0263242 14.2799 0C14.2947 0.133715 14.3009 0.267438 14.3009 0.400101V0.400114Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_349_2668">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
